import { LoadingIndicator } from '@cfa/react-components';
import { FC, lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Overlay from '../components/Overlay';
import Root from './Root';
import RouteConstants from './RouteConstants';

const Home = lazy(() => import('../containers/Home'));
const SelectStore = lazy(() => import('../containers/SelectStore'));

const MaintenanceMode = lazy(() => import('../containers/MaintenanceMode'));
const Help = lazy(() => import('../containers/Help'));
const Guide = lazy(() => import('../containers/Guide'));

const History = lazy(() => import('../containers/History'));
const PastChanges = lazy(() => import('../containers/History/PastChanges'));
const AddedToCart = lazy(() => import('../containers/History/AddedToCart'));

const SystemTools = lazy(() => import('../containers/SystemTools'));
const ServicePointClassic = lazy(
  () => import('../containers/SystemTools/ServicePointClassic'),
);
const Status = lazy(
  () => import('../containers/SystemTools/ServicePointClassic/Status'),
);
const Troubleshoot = lazy(
  () => import('../containers/SystemTools/ServicePointClassic/Troubleshoot'),
);
const Reports = lazy(() => import('../containers/Reports/index'));
const ReportsDetail = lazy(() => import('../containers/Reports/ReportsDetail'));

const router = createBrowserRouter([
  {
    path: RouteConstants.MAINTENANCE_MODE,
    element: <MaintenanceMode />,
  },
  {
    path: RouteConstants.HOME,
    element: <Root />,
    children: [
      {
        path: RouteConstants.HOME,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <Home />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.SELECT_STORE,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <SelectStore />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.HISTORY,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <History />
          </Suspense>
        ),
        children: [
          { path: RouteConstants.HISTORY, element: <PastChanges /> },
          { path: RouteConstants.ADDED_TO_CART, element: <AddedToCart /> },
        ],
      },
      {
        path: RouteConstants.HELP,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <Help />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.GUIDE,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <Guide />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.SYSTEM_TOOLS,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <SystemTools />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.STATUS,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <ServicePointClassic />
          </Suspense>
        ),
        children: [
          { path: RouteConstants.STATUS, element: <Status /> },
          { path: RouteConstants.TROUBLESHOOT, element: <Troubleshoot /> },
        ],
      },
      {
        path: RouteConstants.REPORTS,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <Reports />
          </Suspense>
        ),
      },
      {
        path: RouteConstants.REPORTS_DETAILS,
        element: (
          <Suspense
            fallback={
              <Overlay isOpen>
                <LoadingIndicator variant="page" />
              </Overlay>
            }
          >
            <ReportsDetail />
          </Suspense>
        ),
      },

      { path: '*' },
    ],
  },
]);

const AppRouter: FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
